import reportWebVitals from "../reportWebVitals";

const MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

// gtag.js is ~150 KB of third-party JavaScript. It is not needed to render the
// page, so it is loaded only once the page has finished loading and the visitor
// has either interacted with it or been there for a few seconds.
const IDLE_DELAY_MS = 5000;
const INTERACTION_EVENTS = ["pointerdown", "keydown", "scroll", "touchstart"];

let started = false;

const trackEvent = (name, params) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

const start = () => {
  if (started) return;
  started = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js expects the `arguments` object itself, not an array.
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Core Web Vitals -> GA (the web-vitals library is its own small lazy chunk).
  reportWebVitals((metric) => {
    if (!metric) return;
    // GA requires event parameters to be strings or numbers.
    trackEvent("web_vitals", {
      id: metric.id,
      name: metric.name,
      value: String(metric.value),
      delta: String(metric.delta),
      rating: metric.rating,
    });
  });
};

/** Schedules Google Analytics to load after the page is done loading. */
export const initAnalytics = () => {
  if (typeof window === "undefined" || !MEASUREMENT_ID) return;

  const schedule = () => {
    let timer;
    const go = () => {
      clearTimeout(timer);
      INTERACTION_EVENTS.forEach((evt) =>
        window.removeEventListener(evt, go)
      );
      start();
    };
    INTERACTION_EVENTS.forEach((evt) =>
      window.addEventListener(evt, go, { passive: true })
    );
    timer = setTimeout(go, IDLE_DELAY_MS);
  };

  if (document.readyState === "complete") {
    schedule();
  } else {
    window.addEventListener("load", schedule, { once: true });
  }
};

export { trackEvent };
